"use strict";
import axios from "axios";
import shaJs from "./sha";
import base64Js from "./base64";
import auth from "plus/auth";
import { Message, Loading } from "element-ui";
import config from "./config";
import { isWorkWechat } from "@/utils/helper"
import { tryHandleLoginInfo401 } from "@/utils/urlTokenLogin";

function getUUid() {
  let uuid = localStorage.getItem("uuid");

  if (uuid) return uuid;
  if (!uuid || uuid == "") {
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    uuid = s.join("");

    localStorage.setItem("uuid", uuid);
    return uuid;
  }
}

const defaultHeaders = async () => {
  let headers;
  headers = {
      deviceplatform: "wap",
      mebdeviceid: getUUid(),
      appid: config.AK,
      nonce: "3343434",
      mebversion: "9.5.0",
  };

  return headers;
};

const options = {};

const instance = axios.create(
  Object.assign(
    {
      // TODO 使用配置文件
      baseURL: config.API_ROOT,
      // baseURL:'http://10.0.0.255:7081',
      // baseURL: 'https://kongdev.meb.im/workorder/auth_resource',
      // baseURL:'http://10.0.0.16:7080',
      headers: {},
      /* `paramsSerializer`是一个可选的函数，负责序列化`params`*/
      // paramsSerializer: (params) => { }, transformRequest: [],//
      // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外
      // 安 装） transformResponse: [], // 这里提前处理返回的数据 params: !accessToken ? {} : {
      // access_token: accessToken },
      params: {},
      data: {},
      // timeout: 1000,//设置超时时间 responseType: 'default', // json//返回数据类型
    },
    options
  )
);

instance.interceptors.request.use(async function(request) {
  let defaults = await defaultHeaders();

  let timestamp = Math.round(Date.now() / 1000).toString();

  defaults["timestamp"] = timestamp;

  let arr = [`appid=${config.AK}`, "nonce=3343434", `timestamp=${timestamp}`];

  let params = request.params || {},
    httpurl = request.url,
    splitParmas = [];

  //post请求参数不签名
  // if (request.method.toLowerCase() === 'get') {
  //链接传参
  if (httpurl.indexOf("?") !== -1) {
    let paramsww = httpurl.split("?")[1];
    if (paramsww.indexOf("&") !== -1) {
      //  alert("附件&"+paramsww)
      splitParmas.push(...paramsww.split("&"));
    } else {
      //  alert("没有&"+paramsww)
      splitParmas.push(paramsww);
    }
  } else {
    // alert("params"+JSON.stringify(params))
    for (let key in params) {
      splitParmas.push(`${key}=${params[key]}`);
    }
  }
  for (var propName in splitParmas) {
    let name = splitParmas[propName].toString();
    if (name.split("=")[1] == "null" || name.split("=")[1] == "undefined") {
      splitParmas.splice(propName, 1);
    }
  }
  arr.push(...splitParmas);
  arr.sort();
  let queryString = arr.join("&") + `&secret=${config.SK}`;
  let sha = shaJs.hex_sha1(queryString);
  let sigture = base64Js.Base64.encode(sha);
  defaults.sigture = sigture;
  defaults.timestamp = timestamp;
  defaults.token = auth.token;
  defaults.user = auth.userInfo ? auth.userInfo : "";
  defaults.permession = auth.menuInfoListPermission
    ? auth.menuInfoListPermission
    : "";
  request.headers = Object.assign(request.headers, defaults);
  //添加随机数
  request.params = {
    // _t: Date.parse(new Date()) / 1000,
    ...request.params,
  };
  return request;
});
instance.interceptors.response.use(
  (response) => {
    if (
      (response.status === 200 && response.data.code === 0) ||
      response.data.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      return response;
    }
    if (tryHandleLoginInfo401(response)) {
      return Promise.reject(response);
    }

    if (response.status === 401) {
      // TODO 跳UC
      window.location.replace(config.UC_HOST);
      return;
    }

    let msg = "";
    if (response.data.msg) {
      msg = response.data.msg;
    }
    if(!isWorkWechat()){
      msg && Message.error(msg);
    }
    return Promise.reject(response);

      // //
      // if (response.data.code == 401) {

    //     // alert(response.data.code)
    //     if (!window.isPlus) {
    //         router.push({ name: "login" });
    //     } else {
    //     }
    //     return Promise.reject(response.data)
    // } else {
    //     return response;
    // }
  },
  (error) => {
    if (error.response && tryHandleLoginInfo401(error.response)) {
      return Promise.reject(error);
    }

    let msg = "";
    if (error.message) {
      msg = error.message;
    }

    // if (error.response) {
    //     switch (error.response.data.code) {
    //         case 401:
    //             if (!window.isPlus) {
    //                 router.push({ name: "login" });
    //             } else {
    //             }
    //     }
    // }
    if(!isWorkWechat()){
      msg && Message.error(msg);
    }
    return Promise.reject(error); // 返回接口返回的错误信息
  }
);
export default instance;
